import { useMutation } from '@tanstack/react-query';
import styled from 'styled-components';

import { TextButton } from '@creditornot/cb-button';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { downloadBlob } from 'common/utils/downloadUtils';
import { downloadOverrideExample } from 'features/override-management/api';

const StyledTextButton = styled(TextButton)`
  margin: 16px 0 0;
`;

export function ExampleFileDownloadButton() {
  const format = useFormatMessage();

  const { mutate } = useMutation({
    mutationFn: downloadOverrideExample,
    onSuccess: (blob) => {
      const fileName = 'override_example.csv';
      downloadBlob(new Blob([blob]), fileName);
    },
  });

  return (
    <StyledTextButton onClick={() => mutate()}>
      {format('common.download_example_file')}
    </StyledTextButton>
  );
}
